import { observer } from 'src/utils/mobx-react';
import {
    ItemButton,
    ItemWrapper,
    VerticalMoveIconWrapper,
} from 'src/components/SportPopup/SportCompetitions/SportCompetitions.style';
import React from 'react';
import styled from '@emotion/styled';
import { SportCompetitionsState } from './SportCompetitionsState';
import { CompetitionId } from 'src_common/common/websocket2/id/WebsocketId';
import { ArrowUpIcon } from 'src/assets/icons/ArrowUpIcon';

const Saving = styled('span', { label: 'Saving' })`
    margin-left: 10px;
    color: red;
`;
const MoveToTheTopIcon = styled(ArrowUpIcon, { label: 'MoveToTheTopIcon' })`
    fill: #000;
    width: 8px;
    height: 8px;
`;
const MoveToTheTopButton = styled('span', { label: 'MoveToTheTopButton' })`
    margin-right: 10px;
    border: 1px solid #000;
    padding: 0px 3px 0px 3px;
    border-radius: 2px;
    cursor: pointer;
    &:hover,
    &:focus {
        background-color: #ccc;
    }
`;

type SportCompetitionsItemPropsType = {
    competitionId: CompetitionId;
    name: string;
    isDragged: boolean;
    state: SportCompetitionsState;
};

export const SportCompetitionsItem = observer('SportCompetitionsItem', (props: SportCompetitionsItemPropsType) => {
    const { competitionId, state } = props;
    const movedId = state.movedId;
    const saving = movedId === competitionId ? <Saving>Saving ...</Saving> : null;
    const isFirstCompetition = state.getCompetitionToMoveIndex(competitionId) === 0;
    return (
        <ItemWrapper>
            {isFirstCompetition ? null : (
                <MoveToTheTopButton onClick={(e) => state.onMoveCompetitionToTheTopHandler(e, competitionId)}>
                    <MoveToTheTopIcon />
                </MoveToTheTopButton>
            )}

            <span>{props.name}</span>
            {saving}
            <ItemButton
                isDragged={props.isDragged}
                data-movable-handle
                tabIndex={-1}
                data-test='item-drag-button'
            >
                <VerticalMoveIconWrapper />
            </ItemButton>
        </ItemWrapper>
    );
});
